import styled, { css } from "styled-components";
import { theme } from "../theme/toyotaTheme";

export const Wrapper = styled.div`
    display: inline-flex;
    padding-left: ${theme.space[3]}px;
    padding-right: ${theme.space[7]}px;
    border-bottom: 1px solid ${theme.colors.grey2};
    @media print {
        display: none;
    }

    html[dir="rtl"] & {
        padding-left: ${theme.space[7]}px;
        padding-right: ${theme.space[3]}px;
    }
`;

export const Item = styled.button<{ active?: boolean }>`
    display: flex;
    position: relative;
    top: 1px;
    flex: 1;
    max-width: 100%;
    padding-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    line-height: 2.4rem;
    white-space: nowrap;
    border-bottom: 1px solid ${theme.colors.grey2};
    transition: border 0.2s;
    cursor: pointer;

    &:first-child {
        margin-right: ${theme.space[3]}px;
    }

    span {
        display: inline-block;
        max-width: 100%;
        text-overflow: ellipsis;
        overflow-x: hidden;
    }

    ${({ active }) =>
        active &&
        css`
            font-family: ${theme.fonts.regular};
            border-color: ${theme.colors.primaryRed};
        `};

    .bz & {
        &[aria-pressed="true"] {
            border-color: ${theme.colors.bz4x};
        }
    }

    html[dir="rtl"] & {
        &:first-child {
            margin-left: ${theme.space[3]}px;
            margin-right: 0;
        }
    }
`;
